let VersionService = function (Restangular) {
    const ServiceAPI = Restangular.all('app_version');

    let getVersionsList = () => {
      return ServiceAPI.customGET();
    } 
  
    let save = (resource) => {
      if (resource.save) {
          return resource.save();
      } else {
          return ServiceAPI.post(resource);
      }
    }
  
    let index = (query) => {
      query = query || {};
      query.deleted_at = 'null';
      return ServiceAPI.getList(query);
    }
  
    let load = (query) => {
      return new Promise((resolve, reject) => {
          getVersionsList(query)
          .then(response => {
              let count = response[0];
              index(query)
              .then(data => {
                  resolve({count, data});
              })
              .catch(err => {
                  reject(err);
              });
          })
          .catch(err => {
              reject(err);
          });
      });
    }

    load(null)
  
    let show = (id) => {
      return ServiceAPI.get(id);
    }
  
    let destroy = (resource) => {
      resource.deleted_at = moment();
      return resource.save();
    }
  
    return { index, load, save, show, destroy } ;
  };
  
  VersionService.$inject = ['Restangular'];
  
  export default VersionService;
  


// WEBPACK FOOTER //
// ./client/app/components/version/version.service.js